import filter from "lodash/filter";
import map from "lodash/map";
import uniq from "lodash/uniq";
import get from "lodash/get";
import isArray from "lodash/isArray";
import isNumber from "lodash/isNumber";

interface Data {
  // tslint:disable-next-line:no-any
  [props: string]: any;
}

/**
 * Given a template interpolates expression with values from data
 *
 *
 * @param template The string template
 * @param data The data object
 */
export function interpolate(
  template: string,
  data: Data,
  defaultToBlank: boolean = false
) {
  const commandRe = /{{([^}}]+)?}}/g;
  let output = `${template}`;

  let match;

  while ((match = commandRe.exec(template))) {
    const allMatches = match[1].split("|");
    const matchCount = allMatches.length;
    const variables =
      matchCount > 1 ? allMatches.slice(0, matchCount - 1) : allMatches;
    const defaultValue =
      matchCount > 1 ? allMatches[matchCount - 1].trim() : "";

    let replaceValue = defaultValue;

    for (let i = 0; i < variables.length; i++) {
      const variable = variables[i];
      const value = resolve(data, variable.trim());

      if (value || isNumber(value)) {
        replaceValue = value;
        break;
      }
    }

    if (replaceValue === "") {
      replaceValue = defaultToBlank ? "" : match[0];
    }

    output = output.replace(match[0], replaceValue);
  }

  return output;
}

interface Dataset {
  [props: string]: Dataset | string | string[] | number;
}

export function resolve(dataset: Dataset, path: string): string {
  const value = get(dataset, path);

  if (typeof value === "string") {
    return value;
  } else if (isArray(value)) {
    return value.join(", ");
  } else if (isNumber(value)) {
    return String(value);
  }

  return "";
}

/**
 * Given a string of emails returns a uniq list of emails. To be used
 * when a user may copy-pasta blobs of contact informations like:
 *     <rachel.chizek@thomsonreuters.com> A Shoucair
 *     5058445026098047351@mg.upwork.com <natalie.lampas@thomsonreuters.com>
 *     Nile Bob Lockwood boczarma@northville.org bonnieabh@aol.com
 *     ...
 * @param recipients string Email blobs
 */
export function getEmailsFromString(recipients: string): string[] {
  return uniq(
    map(
      filter(recipients.replace(/[<>;,:()]/g, " ").split(/\s/), (email) =>
        /.+@.+\..+/.test(email)
      ),
      (email) => email.toLowerCase()
    )
  );
}

export function generateErrorId(key: string) {
  return `${key.replace(/[.\s]/g, "")}-Error`;
}

export const couponRegex = /{{\s*coupon\s*}}/g;
